<style scoped lang="scss" type="text/scss">
.recommendation-container {
    .submit-buttons {
        margin-top: 1rem;
    }
}
</style>

<template>
    <div class="recommendation-container">
        <block-divider>物资购买联系人</block-divider>
        <current-registrable-managed-player-members-selector
            v-model="purchasingIds" placeholder="请选择"
        >
        </current-registrable-managed-player-members-selector>

        <block-divider>淘宝账号(用于购买教育优惠物资，提交后不可修改)</block-divider>
        <el-input v-model.trim="taoBaoAccount" placeholder="注意：请输入淘宝账号名，非昵称！！！"></el-input>

        <div class="submit-buttons">
            <el-button type="primary" plain @click="update()" :loading="requesting">保存</el-button>
            <el-button @click="reset()">重置</el-button>
        </div>
    </div>
</template>

<script>
import BlockDivider from '../../../../../components/divider/block';
import CurrentRegistrableManagedPlayerMembersSelector
    from '../../../../sub-components/current-registrable-managed-player-members-selector/index';
import {mapState} from 'vuex';
import _ from 'lodash';

export default {
    name: '',
    components: {
        BlockDivider,
        CurrentRegistrableManagedPlayerMembersSelector
    },
    data () {
        return {
            purchasingIds: [],
            taoBaoAccount: "",
            requesting: false
        };
    },
    computed: {
        ...mapState('player', {
            currentManagedPlayerId: state => state.currentManagedPlayerId,
            currentManagedPlayerPurchasing: state => state.currentManagedPlayerPurchasing,
            currentManagedPlayerPurchasingIds: state => state.currentManagedPlayerPurchasingIds,
            currentManagedPlayerTaoBaoAccount: state => state.currentManagedPlayerTaoBaoAccount,
        })
    },
    watch: {
        currentManagedPlayerId: {
            immediate: true,
            handler (currentManagedPlayerId) {
                if (currentManagedPlayerId === null || currentManagedPlayerId === undefined) return;
                this.loadMembers();
                this.loadPurchasing();
                this.loadTaoBaoAccount();
            }
        },
        currentManagedPlayerPurchasing: {
            immediate: true,
            handler () {
                this.resetVariables();
            }
        }
    },
    methods: {
        update () {
            if (this.purchasingIds.length === 0) {
                this.$tip('请推荐至少一名物资购买联系人');
                return;
            }
            if (this.taoBaoAccount.length === 0) {
                this.$tip('注意：请填写淘宝账号名，非昵称！！！');
                return;
            }
            // if (this.purchasingIds.length === 0) {
            //     this.$tip('请推荐至少一名物资购买联系人');
            //     return;
            // }

            const params = {
                id: this.currentManagedPlayerId,
                purchasing: this.purchasingIds,
                taobao_account: this.taoBaoAccount,
            };
            this.$normalRequest('player/assignPurchasing', params, '物资购买信息保存成功', true, this, 'requesting').then(_ => {
                this.loadPurchasing();
                this.loadTaoBaoAccount();
            }).catch(_ => {
            });
            // const purchasingParams = {
            //     id: this.currentManagedPlayerId,
            //     purchasing: this.purchasingIds,
            // };
            // this.$normalRequest('player/assignPurchasing', purchasingParams, '物资购买信息保存成功', true, this, 'requesting').then(_ => {
            //     this.loadPurchasing();
            // }).catch(_ => {
            // });
            // const taoBaoAccountParams = {
            //     id: this.currentManagedPlayerId,
            //     taoBaoAccount: this.taoBaoAccount,
            // };
            // this.$normalRequest('player/assignTaoBaoAccount', taoBaoAccountParams, '物资购买信息保存成功', true, this, 'requesting').then(_ => {
            //     this.loadTaoBaoAccount();
            // }).catch(_ => {
            // });
        },
        reset () {
            this.loadPurchasing();
            this.loadTaoBaoAccount();
        },
        loadPurchasing () {
            this.$store.dispatch('player/loadPurchasing', {
                id: this.currentManagedPlayerId
            }).then(response => {
            });
        },
        loadTaoBaoAccount () {
            this.$store.dispatch('player/loadTaoBaoAccount', {
                id: this.currentManagedPlayerId
            }).then(response => {
                this.taoBaoAccount = response.data.taobao_account;
                // console.log(response)
                // console.log(this.state.currentManagedPlayerTaoBaoAccount)
            });
        },
        loadMembers () {
            this.$store.dispatch('player/loadMembers', {
                id: this.currentManagedPlayerId
            }).then();
        },
        resetVariables () {
            this.purchasingIds = _.cloneDeep(this.currentManagedPlayerPurchasingIds);
            this.taoBaoAccount = _.cloneDeep(this.currentManagedPlayerTaoBaoAccount);
        }
    }
};
</script>
